import { titleCase } from '~app/shared/functions/utils/utils.function';

export class EffectItem {
  private readonly data: {
    activeStatus: string;
    docType: string;
    effectCode: string;
    effectDescription: string;
    sortOrder: number;
  };

  constructor(data: any) {
    this.data = data;
  }

  public get code(): string {
    return this.data.effectCode;
  }

  public get name(): string {
    return titleCase(this.data.effectDescription);
  }
}
